import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Hide on /pricing — the mobile Live Basket dock occupies the bottom-right
  if (location.pathname === '/pricing') return null;
  if (!visible) return null;

  return (
    <button
      data-testid="back-to-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-[#0A0A0A] dark:bg-[#8B5CF6] text-white shadow-lg flex items-center justify-center hover:bg-[#00E5FF] hover:text-[#0A0A0A] dark:hover:bg-violet-400 transition-all fade-up-in hover:scale-110"
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
}
